var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightDarkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52876 13.1377C5.26841 12.8774 5.26841 12.4553 5.52876 12.1949L9.72402 7.99967L5.52876 3.80441C5.26841 3.54406 5.26841 3.12195 5.52876 2.8616C5.78911 2.60125 6.21122 2.60125 6.47157 2.8616L11.1382 7.52827C11.2633 7.65329 11.3335 7.82286 11.3335 7.99967C11.3335 8.17649 11.2633 8.34606 11.1382 8.47108L6.47157 13.1377C6.21122 13.3981 5.78911 13.3981 5.52876 13.1377Z",
    fill: "#4A5564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDarkGrey);
export default __webpack_public_path__ + "static/media/chevron-right-dark-grey.5ad740350b8d39ed8f04b3df8a193e85.svg";
export { ForwardRef as ReactComponent };